import styled from 'styled-components/macro';
import { blue2, gulfBlue } from '../common/colorConstants';

export const Container = styled.div`
  background-color: #fff;
  position: absolute;
  bottom: 0px;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 0;
  overflow-y: scroll;
  display: flex;
`;

export const Holder = styled.div`
  min-height: 410px;
  width: 426px;
  margin: 0px auto;
  @media (max-width: 470px) {
    width: 100%;
  }
`;

export const PasswordResetBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Lato';
  align-self: center;
  margin-top: 120px;
  margin-bottom: 120px;
  padding: 60px 0px 0px 0px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.38);
  @media (max-width: 470px) {
    margin-top: 20px;
    margin-bottom: 73px;
    border-radius: 0px;
  }
`;

export const FormComponentsContainer = styled.div`
  width: 100%;
  margin: 0px;
  padding: 0px;
`;

export const Logo = styled.img`
  width: 25px;
  margin-bottom: 10px;
`;

export const FormContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 20px 30px 20px;
`;

export const Title = styled.div`
  color: ${gulfBlue};
  font-size: 25px;
  font-weight: 400;
  margin-bottom: 25px;
  @media (max-width: 470px) {
    font-size: 20px;
    text-align: center;
  }
`;

export const FormItem = styled.div`
  width: 100%;
  margin-left: 20px;
  margin-right: 20px;
`;

export const ServerError = styled.div`
  color: red;
  margin: 20px 0px 0px 0px;
  text-align: center;
  font-size: 14px;
  font-weight: 300;
`;

export const Error = styled.div`
  color: red;
  margin-top: 3px;
  font-size: 16px;
  font-weight: 300;
`;

export const ServerErrorMessage = styled.div`
  display: ${(props) => (props.hide ? 'none' : 'initial')};
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 28px;
  font-size: 18px;
  margin-bottom: 0px;
  background-color: ${blue2};
  color: white;
  border: none;
  border-radius: 0px 0px 10px 10px;
  transition: 0.3s;
  outline: none;

  @media (max-width: 470px) {
    border-radius: 0px;
  }
`;

export const RememberPasswordContainer = styled.div`
  margin-top: 40px;
  color: #22386f;
  text-align: center;
  padding: 0px 10px;
  font-size: 11px;
`;

export const InfoIcon = styled.img`
  margin: 0;
  width: 14px;
  height: 14px;
  z-index: 100;
  cursor: pointer;
  position: relative;
  top: ${(props) =>
    // eslint-disable-next-line
    props.passwordError
      ? props.passwordVerifyError
        ? '-119px'
        : '-99px'
      : props.passwordVerifyError
      ? '-115px'
      : '-88px'};
  left: 110px;
  @media (max-width: 470px) {
    display: none;
  }
`;

export const ReCAPTCHAWrapper = styled.div`
  justify-content: center;
  padding-top: 20px;
`;

export const ReCaptchaError = styled.div`
  color: red;
  margin-top: 13px;
  margin-left: 10px;
  font-size: 12px;
  font-weight: 300;
`;
